
import { delay } from '@okta/okta-auth-js';
import { APIEnum } from '../constants/api-enum';
import { apiHelperGenerateRefreshToken } from '../utils/utils';
import { IPublicClientApplication } from '@azure/msal-browser';
export type AssetType = {
  assetId: string;
  assetName: string;
  parentAssetId: string;
};


export type requestType = 'GET' | 'POST' | 'PUT' | 'DELETE';


function getIdToken(instace: any) {

  if(instace)
     isTokenExpired(instace);

     let idToken = localStorage.getItem('idToken') || sessionStorage.getItem('idToken') ;
  if (!idToken) {
        // If idToken is not found in localStorage or sessionStorage, try to get it from MSAL session
    console.log('idToken not found in localStorage or sessionStorage or token expires, trying to retrieve from MSAL session');
    idToken = getMsalIdTokenFromSession();
     localStorage.setItem('idToken', JSON.stringify(idToken));
     sessionStorage.setItem('idToken', JSON.stringify(idToken));
  }
  return idToken;
}

function getMsalIdTokenFromSession() {
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key && key.includes('idToken')) {
      const value = sessionStorage.getItem(key);
          console.log('Found idToken in sessionStorage:', key, value);
      try {
        // MSAL stores the raw token as the value
        if (value && value.startsWith('eyJ')) { // Basic check for JWT format
             return value;
        }
       
      } catch (e) {
        // If value is not a raw token, try parsing as JSON
        try {
          const parsed = JSON.parse(value || '{}');
          if (parsed.idToken) return parsed.idToken;
        } catch {
          // Ignore
        }
      }
    }
  }
  return null;
}

function isTokenExpired(instace: any) {
   const expiresAt = localStorage.getItem('expiresAtAccess'); // e.g., returns a timestamp
  
  const expiresAt1 = expiresAt ? parseInt(expiresAt, 10) : 0
  const now = Date.now(); // current time in milliseconds
  const currentTime = Math.floor(Date.now() / 1000);
   if (currentTime >= expiresAt1) {
       console.log('IdToken expired in API helper:');
         let idToken = localStorage.getItem('idToken');
          console.log('Before New Token generate :'+idToken);
        apiHelperGenerateRefreshToken(instace);
     // await delay(3000);  
        let idToken1 = localStorage.getItem('idToken'); 
          console.log('After New Token generate :'+idToken1);
  }
}
      



const apiRequest = async (url = '', data = {}, type: requestType, isModeGiven?:boolean, modeType?:string , instace ?: IPublicClientApplication) => {
    // Default options are marked with *
  let methodType: requestType = type;
  let headerObject: any = {
    method: methodType, // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json',
      //commnet line 48 and  un comment 49  and  replace the token to  work in local environment
    //  Authorization: `Bearer ${JSON.parse(localStorage.getItem('okta-token-storage') || '{}')?.accessToken?.accessToken}`,
     Authorization: `Bearer ${getIdToken(instace)}`,

    },

    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
  };
  //add new header based on the mode given
  if(isModeGiven)
  headerObject = {...headerObject, headers: {...headerObject.headers, 'Mode-Type': modeType}};
  // For get request body no need
  if (type !== APIEnum.GET) {
    headerObject.body = JSON.stringify(data);
  }

  const response = await fetch(url, headerObject);

  if (response.status === 401) {
    return;
  } else if (response.status === 503) {
    let errJson = {
      status: 'Failure',
      errors: [
        {
          status: 'ROD-9001',
        },
      ],
    };
    return errJson;
  } else if (response.status === 204 || response.status === 404) {
    return;
  } else {
    return response.json(); // parses JSON response into native JavaScript objects
  }
};

export default apiRequest;
